import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1>Color Backgrounds</h1>
      <div className="header-content">
        <p className="header-description">
          Welcome to Color Backgrounds, your one-stop destination for high-quality background images. 
          We offer a carefully curated collection of backgrounds in various colors and shades, 
          perfect for your web design, presentations, digital art, and other creative projects.
        </p>
      </div>
    </header>
  );
}

export default Header; 